import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { _Agency, _CommercialCampaign, _CountriesVdos, _DistributionChannel } from '../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../theme/Component/usePaginator';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { AccountEditor } from '../../../editor/AccountEditor';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const CountriesEditor = ({ idSelector, onChange, label, returnType = "ID",render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_CountriesVdos)
    const paginador = usePaginator();

    const [valor, setValor] = useState<string>(render ?? "");

    const [regexStr, setregexStr] = useState<any>(null);

    const modal = useModal("Pais", MODAL_LG);


    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDCountries == e
            );
            if (selectedItem) {
                setValor(`${selectedItem.DataBeanProperties.ISO3} - ${selectedItem.DataBeanProperties.Name}`)
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getCountriesCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDCountries', visible: true },
        { title: 'ID Región', property: 'IDRegion', visible: true },
        { title: 'Región', property: 'Region', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'ISO3', property: 'ISO3', visible: true },
        { title: 'Símbolo Moneda', property: 'CurrencySimbol', visible: true },
        { title: 'Moneda', property: 'Currency', visible: true },
        { title: 'Emojiu', property: 'Emojiu', visible: true },
        { title: 'Latitud', property: 'Latitude', visible: true },
        { title: 'Longitud', property: 'Longitude', visible: true },
        { title: 'Nacionalidad', property: 'Nationality', visible: true },
        { title: 'Capital', property: 'Capital', visible: true },
        { title: 'Código Telefónico', property: 'PhoneCode', visible: true },
        { title: 'Código Numérico', property: 'NumericCode', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }

    return (
        <>
            <label>{label ?? "Paises"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{valor ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDCountries); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    </div>
                </div>

            </Modal>
        </>
    )
}